import { Alert, Divider, refundMethods } from '@reveni-io/reveni-ui'

import {
  getDisplayErrorField,
  getRefundMethodFieldId,
} from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/helpers'

import AvailabilitySelector from './AvailabilitySelector/AvailabilitySelector'
import CustomName from './CustomName/CustomName'
import DescriptionMessage from './DescriptionMessage/DescriptionMessage'
import GiftCardConfiguration from './GiftCardConfiguration/GiftCardConfiguration'
import useRefundMethodContent from './hooks/useRefundMethodContent/useRefundMethodContent'
import StoreCreditConfiguration from './StoreCreditConfiguration/StoreCreditConfiguration'
import * as Styles from './styles'

const RefundMethodContent = ({
  refundMethod,
  savedRefundMethod,
  languages,
  subscriptionPlan,
  allowInstantTransactions,
  isEditable,
  storeCurrencySymbol,
  provider,
  errors,
  onChange,
}) => {
  const handlers = useRefundMethodContent({ refundMethod, savedRefundMethod, onChange })

  return (
    <Styles.Container>
      <DescriptionMessage refundMethodType={refundMethod.name} />
      {errors?.non_field_errors && <Alert type="error">{errors.non_field_errors.join(' ')}</Alert>}
      <CustomName
        languages={languages}
        onChangeCustomName={handlers.handleChangeCustomName}
        customNames={refundMethod.display}
        onCheckUseCustomName={handlers.handleToggleCustomName}
        useCustomName={refundMethod.useCustomName}
        disabled={!isEditable}
        errorLanguages={languages.filter(language => errors?.[getDisplayErrorField(language)])}
        fieldId={getRefundMethodFieldId(refundMethod.name, 'display')}
      />
      <Divider />
      <AvailabilitySelector
        instantAllowed={refundMethod.instant_allowed}
        originalInstantAllowed={savedRefundMethod.instant_allowed}
        onChange={handlers.handleChangeInstantAllowed}
        refundMethodType={refundMethod.name}
        subscriptionPlan={subscriptionPlan}
        allowInstantTransactions={allowInstantTransactions}
        disabled={!isEditable}
      />
      {errors?.instant_allowed && <Alert type="error">{errors.instant_allowed.join(' ')}</Alert>}
      {refundMethod.name === refundMethods.giftCard && (
        <>
          <Divider />
          <GiftCardConfiguration
            duration={refundMethod.duration}
            onChangeInputDuration={handlers.handleChangeDurationNumber}
            onChangeSelectDuration={handlers.handleChangeDurationType}
            onChangeToggleExpirationSelect={handlers.handleToggleExpiration}
            extraValueType={refundMethod.extra_value_type}
            handleExtraValueType={handlers.handleChangeExtraValueType}
            extraValue={refundMethod.extra_value}
            handleExtraValue={handlers.handleChangeExtraValue}
            maxExtraAmount={refundMethod.max_extra_amount}
            handleMaxExtraAmount={handlers.handleChangeMaxExtraAmount}
            minEligibleRefundAmount={refundMethod.min_eligible_refund_amount}
            handleMinEligibleRefundAmount={handlers.handleChangeMinEligibleRefundAmount}
            storeCurrencySymbol={storeCurrencySymbol}
            errors={errors}
            refundMethodName={refundMethod.name}
            allowExtraWhenPaidWithCredit={refundMethod.allow_extra_when_paid_with_credit}
            handleAllowExtraWhenPaidWithCredit={handlers.handleChangeAllowExtraWhenPaidWithCredit}
            disabled={!isEditable}
          />
        </>
      )}
      {refundMethod.name === refundMethods.storeCredit && (
        <>
          <Divider />
          <StoreCreditConfiguration
            duration={refundMethod.duration}
            onChangeInputDuration={handlers.handleChangeDurationNumber}
            onChangeSelectDuration={handlers.handleChangeDurationType}
            extraValueType={refundMethod.extra_value_type}
            handleExtraValueType={handlers.handleChangeExtraValueType}
            extraValue={refundMethod.extra_value}
            handleExtraValue={handlers.handleChangeExtraValue}
            maxExtraAmount={refundMethod.max_extra_amount}
            handleMaxExtraAmount={handlers.handleChangeMaxExtraAmount}
            minEligibleRefundAmount={refundMethod.min_eligible_refund_amount}
            handleMinEligibleRefundAmount={handlers.handleChangeMinEligibleRefundAmount}
            storeCurrencySymbol={storeCurrencySymbol}
            provider={provider}
            errors={errors}
            refundMethodName={refundMethod.name}
            discountCombinations={refundMethod.discount_combinations}
            onChangeDiscountCombinations={handlers.handleChangeDiscountCombinations}
            allowExtraWhenPaidWithCredit={refundMethod.allow_extra_when_paid_with_credit}
            handleAllowExtraWhenPaidWithCredit={handlers.handleChangeAllowExtraWhenPaidWithCredit}
            disabled={!isEditable}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default RefundMethodContent
